module.exports = __webpack_public_path__ + "static/media/mxr.5448b352.svg";